export const AMPLITUDE_API_KEYS = {
  homes: {
    production: 'c1ce0aad5e034dc04464339ebb6f9944',
    dev: 'de37503f8ccbb79fbc77c2e4f35ec4ad',
  },
  'simple-machines': {
    production: '333d5d4571c112c02537f878c5cf499e',
    dev: '61b0dc7a1dc92f371020a91446511ccf',
  },
  earth: {
    production: 'dc1cf0ac142b080bfcce989476ed49d0',
    dev: '22ce9f78a818419128c704782cf2c0f7',
  },
  weather: {
    production: '6f81d6d377aa34f56902501a7fc1b2b4',
    dev: '3cba426ff577b441d37ae9e34f6dccbf',
  },
  skyscrapers: {
    production: '1c02a2967a301052be3d146631d81542',
    dev: '86b7cb7f569cc5b515552bbf40abbf9a',
  },
  space: {
    production: '5c97c87e205e33b4d47e13e2cb38dfa9',
    dev: 'b53664c014d99d2909734b88552ad88e',
  },
  'human-body': {
    production: '9086f55ade9f2f66f9709aeebef21aba',
    dev: 'a7bcd5c70d670d567054f680ab7db3ac',
  },
  mammals: {
    production: 'bd38fe3f5967ae9a6c0ad5d19c45f318',
    dev: '9a77991e38df7996a86137ac260af42b',
  },
  'coral-reef': {
    production: '82979732f6b97c9aec4f1674684ad8f3',
    dev: '4346d22107b357346eaeb2934ce02b3b',
  },
  'states-of-matter': {
    production: 'e6d949f1a83d0e019e28a6eef62eb6ed',
    dev: 'f2800964da581921d7ce5da3fe5746e6',
  },
  'web-client': {
    production: 'b482c6a2fee094b1b269d7b69c93b87e',
    dev: '0f90156531e51cfcc8c35b10c1f6cb5c',
  },
};

const defaultEventLabels = {
  audio: {
    eventName: 'Tap Sound Button',
    propertyName: 'Setting',
    true: 'On',
    false: 'Off',
  },
  labels: {
    eventName: 'Tap Label Button',
    propertyName: 'Setting',
    true: 'On',
    false: 'Off',
  },
  currentLanguage: {
    eventName: 'Tap Language Button',
    propertyName: 'Setting',
  },
};

export const AMPLITUDE_EVENT_LABELS = {
  homes: {
    // Tap Label Button does not exist in Amplitude
    ...defaultEventLabels,
    currentLanguage: {
      ...defaultEventLabels.currentLanguage,
      eventName: 'Tap Language',
      propertyName: 'Set Language',
    },
    audio: {
      ...defaultEventLabels.audio,
      true: 'ON',
      false: 'OFF',
    },
  },
  'simple-machines': {
    // Each of these events exist in Amplitude, but there are no properties.
    ...defaultEventLabels,
    currentLanguage: {
      ...defaultEventLabels.currentLanguage,
      eventName: 'Tap Language',
      propertyName: 'Setting',
    },
  },
  earth: {
    // None of these exist in Amplitude yet.
    ...defaultEventLabels,
  },
  weather: {
    // Tap Sound does not exist in Amplitude
    ...defaultEventLabels,
    labels: {
      ...defaultEventLabels.labels,
      true: 'on',
      false: 'off',
    },
    audio: {
      ...defaultEventLabels.audio,
      true: 'on',
      false: 'off',
    },
  },
  skyscrapers: {
    // Tap Language Button does not exist in Amplitude
    ...defaultEventLabels,
  },
  space: {
    // Tap Language Button does not exist in Amplitude
    ...defaultEventLabels,
    labels: {
      ...defaultEventLabels.labels,
      eventName: 'Tap Label button',
    },
  },
  'human-body': {
    ...defaultEventLabels,
  },
  'coral-reef': {
    ...defaultEventLabels,
  },
  'states-of-matter': {
    ...defaultEventLabels,
  },
  mammals: {
    // Tap Language Button does not exist in Amplitude
    ...defaultEventLabels,
  },
};
